import React from "react";
import { Box, Typography } from "@material-ui/core";

import { CardUser } from "../CardUser";
import { useStyles } from "./styles";

export const ListUsersApproved = ({ users = [] }) => {
  const classes = useStyles();

  return (
    <Box>
      <Typography className={classes.resultsText}>
        Listando {users.length} resultado{users.length !== 1 && 's' }
      </Typography>
      {users.map((user) => (
        <CardUser isApproved key={user.id} user={user} />
      ))}
    </Box>
  );
};
